// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header{padding:0 20px;height:50px;border-bottom:1px solid #e8eaec;margin-bottom:30px}.header .templateName{font-size:16px;margin-bottom:15px}.groupName{position:relative;font-weight:700;font-size:14px;padding-left:10px}.groupName:before{position:absolute;left:0;content:\"\";padding-left:3px;width:1px;top:4px;height:16px;background:#5fc5ce;font-size:12px}.gary-text{color:#999}:deep(.ivu-steps)-tail{display:none!important}", ""]);
// Exports
module.exports = exports;
